//export const SERVER_URL = "http://15.206.172.137:5001/";
export const SERVER_URL = "https://apis.jalodbust.com/";
//export const SERVER_URL = "http://localhost:80/";
const API = "api/";
const VERSION = "v1/";
export const API_HOST = SERVER_URL + API + VERSION;
